import React, { createContext, useCallback, useContext, useState } from 'react';
import api from '../../service/api';

interface AuthState {
  token: string;
}

interface SignInCredentials {
  login: string;
  senha: string;
}

interface AuthContextData {
  jwt: string
  signIn(credentials: SignInCredentials): Promise<void>;
  signOut(): void;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

const AuthProvider: React.FC = ({children}) => {
  const [jwt, setJwt] = useState<AuthState>(() => {
    const token = localStorage.getItem('@GerenciarDB:token');    

    if (token) {
      return { token };
    }

    return {} as AuthState;
  });

  const signIn = useCallback(async ({ login, senha }): Promise<void> => {
    const response = await api.post('/login',{ login, senha });
    const { jwt } = response.data;

    localStorage.setItem('@GerenciarDB:token', jwt); 
    
    setJwt({ token: jwt });
  }, []);

  const signOut = useCallback((): void => {
    localStorage.removeItem('@GerenciarDB:token');    

    setJwt({} as AuthState);
  }, []);

  return (
    <AuthContext.Provider value={{jwt: jwt.token, signIn, signOut}}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  if (!context) throw new Error('useAuth must be used within an AuthProvider');

  return context;
}

export default AuthProvider;